import { useTranslation } from "react-i18next";

import { Block, SvgIcon, Typography, palette } from "@stepapp/ui";
import React from "react";

const StripeSafePayment = () => {
  const { t } = useTranslation();

  return (
    <Block alignCenter row>
      <Block alignCenter justifyCenter paddingRight={0.5}>
        <SvgIcon color={palette.primary.accent} name="lock" size={24} />
      </Block>
      <Block row paddingTop={0.25}>
        <Typography type="accent" variant="paragraph">
          {t("screens.serviceSummary.yourDataIsSecureThanksTo")}
        </Typography>
        <Block paddingLeft={0.75}>
          <Typography type="accent" variant="newBodyBold">
            {t("common.stripe")}
          </Typography>
        </Block>
      </Block>
    </Block>
  );
};

export default React.memo(StripeSafePayment);
